export const getImagePath = name => {
  return process.env.PUBLIC_URL + `/assets/${name}`;
};